import { useEffect, useState } from 'react';

/**
 * SSR-safe lg-breakpoint check (false on the server — desktop assumption).
 */
export const useIsBelowLg = (): boolean => {
    const [belowLg, setBelowLg] = useState(false);
    useEffect(() => {
        const query = window.matchMedia('(max-width: 1023.98px)');
        setBelowLg(query.matches);
        const onChange = () => setBelowLg(query.matches);
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, []);
    return belowLg;
};
